import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Box, Typography, Button, Grid, TextField
} from '@mui/material';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import { modernTheme } from '../theme';

const ProfileDialog = ({ open, onClose, loading, profileData, onChange, onSubmit }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth
      PaperProps={{ sx: { borderRadius: 3, overflow: 'hidden' } }}
    >
      <DialogTitle sx={{ background: modernTheme.gradients.secondary, color: 'white', py: 2.5 }}>
        <Box display="flex" alignItems="center" gap={1.5}>
          <Box sx={{
            width: 40, height: 40, borderRadius: 2,
            bgcolor: 'rgba(255,255,255,0.2)',
            display: 'flex', alignItems: 'center', justifyContent: 'center'
          }}>
            <ManageAccountsIcon />
          </Box>
          <Box>
            <Typography variant="h6" fontWeight={700}>Cập nhật thông tin cá nhân</Typography>
            <Typography variant="caption" sx={{ opacity: 0.85 }}>
              Thông tin tài khoản & ngân hàng
            </Typography>
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ pt: 3, pb: 1 }}>
        <Grid container spacing={2.5}>
          <Grid item xs={12}>
            <TextField fullWidth label="Họ và tên" name="fullName"
              value={profileData.fullName} onChange={onChange}
              sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField fullWidth label="Số tài khoản ngân hàng" name="bankAccount"
              value={profileData.bankAccount} onChange={onChange}
              sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField fullWidth label="Tên ngân hàng" name="bankName"
              value={profileData.bankName} onChange={onChange}
              sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField fullWidth label="Tên chủ sở hữu ngân hàng" name="bankAccountHolder"
              value={profileData.bankAccountHolder} onChange={onChange}
              sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField fullWidth label="KPI - Số giờ live mục tiêu/kỳ" name="kpiHoursPerPeriod"
              type="number" value={profileData.kpiHoursPerPeriod} onChange={onChange}
              inputProps={{ min: 0, max: 720 }}
              helperText="Mục tiêu số giờ livestream trong 1 kỳ (0-720 giờ)"
              sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3, pt: 2 }}>
        <Button onClick={onClose} variant="outlined" sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600 }}>
          Hủy
        </Button>
        <Button onClick={onSubmit} variant="contained" disabled={loading}
          sx={{
            background: modernTheme.gradients.secondary,
            borderRadius: 2, textTransform: 'none', fontWeight: 600, px: 3,
            '&:hover': { background: modernTheme.gradients.secondary, boxShadow: modernTheme.shadows.md },
          }}
        >
          {loading ? 'Đang lưu...' : 'Lưu thông tin'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProfileDialog;
